export class ParametroAutonomia {
    id: number;
    nombre: string;
    userCreation: string;
    dateCreation?: string;
    userLastUpdate?: string;
    dateLastUpdate?: string;
}
